import React, { useState } from "react";
import PropTypes from 'prop-types';
import { Modal } from "react-bootstrap";
import {
  MdChevronLeft,
  MdChevronRight,
  MdClose
} from "react-icons/md";

//styles
import "./gallery.scss";

const Tile = (props) => {
  const [modalShow, setModalShow] = useState(false);
  const [index, setIndex] = useState(props.index);

  const handleModalClose = () => {
    setIndex(props.index);
    setModalShow(false);
  };
  const handleModalShow = () => setModalShow(true);

  return (
    <>
      <div className="tile">
        <img
          onClick={handleModalShow}
          src={props.data.image}
          alt={props.data.category}
          className="tile-style"
          draggable={false}
        />
      </div>

      <Modal
        show={modalShow}
        onHide={handleModalClose}
        size="xl"
        dialogClassName="modal-100w modal-gallery"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <div className="closeButton">
          <MdClose
            className="style-button"
            size={35}
            onClick={handleModalClose}
          />
        </div>
        <div className="content-image-modal">
          <div>
            {index !== 0 && (
              <MdChevronLeft
                className="style-button"
                size={35}
                onClick={() => setIndex(index - 1)}
              />
            )}
          </div>
          <img
            src={props.images[index].image}
            className="style-image"
            alt="Img gallery"
            draggable={false} />
          <div>
            {index !== (props.images.length - 1) && (
              <MdChevronRight
                className="style-button"
                size={35}
                onClick={() => setIndex(index + 1)}
              />
            )}
          </div>
        </div>
      </Modal>
    </>
  );
};

Tile.propTypes = {
  data: PropTypes.object,
  index: PropTypes.number,
  images: PropTypes.array
};

export default Tile;
